<div class="zmt-snack-container">
  <div>
    <mat-icon class="s-20 text-white">{{ icon }}</mat-icon>
    <span class="ml-8 font-size-14 text-white text-super new-line">{{ data?.message }}</span>
  </div>
  <div>
    <span class="s-20 text-white c-pointer ml-20" (click)="close()">X</span>
  </div>
</div>
